import React, { useState, useEffect } from "react";
import './About.css'

// Images
import LandingAboutimg from "../IMAGES-ADHIBA/ABOUTPAGE/ABOUT2.png"
import Aboutimg1 from "../IMAGES-ADHIBA/ABOUTPAGE/ABOUT1.png"

import ourvisionimg1 from "../IMAGES-ADHIBA/OURBUSINESSPAGE/OURVISIONIMG1.png"
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary, {
    accordionSummaryClasses,
} from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

import Footer from "../footer";


import { Link } from "react-router-dom";
import Testimonial from "../TESTIMONIALS/adhibatesti";

export default function Aboutadhiba() {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    // const [expanded, setExpanded] = useState(false);

    // const handleChange = (panel) => (event, isExpanded) => {
    //     setExpanded(isExpanded ? panel : false);
    // };

    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    return (
        <>
            {/* LANDING BANNER ABOUT US */}
            <section className="Landing-banner-aboutus" >
                <div>
                    <img src={LandingAboutimg} className="img-fluid w-100" style={{ borderRadius: "0%" }} />
                </div>
            </section>

            {/* ABOUT US DESIGN LEFT AND RIGHT CARD DESIGN */}
            <section className="left-right-card-adhiba ">
                <div className="container">
                    <div className="col-12">
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="">
                                    <img src={Aboutimg1} className="img-fluid" />
                                </div>
                            </div>
                            <div className="col-lg-6 right-contents-adhiba">
                                <h3>About us</h3>
                                <p style={{ textAlign: "justify" }}>Headquartered in Coimbatore, Adhiba Technologies is a leading innovator in electronic manufacturing, specializing in smart home solutions, as well as hardware and software development. With over a decade of industry expertise, we are driven by our core principles of Best Quality, Right Cost, and On-Time Delivery. Our cutting-edge products blend advanced technology with precision manufacturing to offer unparalleled convenience, performance, and reliability. Committed to redefining modern living, Adhiba Technologies delivers exceptional value through superior products and outstanding service, ensuring customer satisfaction at every touchpoint. We continuously strive to exceed expectations and empower the future of smart living.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* ACCORDIAN AND LEFT CONTENT DESIGN */}
            <section className="Accordion-About-Adhiba container">
                <div className="col-12">
                    <div className="row">
                        <div className="col-lg-6 left-about-contents-adhiba">
                            <div>
                                <h3>Why choose us?</h3>
                                <p>Adhiba Technologies combines cutting-edge innovation, precision manufacturing, and unparalleled service to deliver high-quality, cost-effective electronic solutions, empowering modern living with smart, reliable, and customer-focused products.</p>
                                <Link to="/adhiba-Ourbusiness"><button className="mt-3">Learn More</button></Link>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            {/* <div class="accordion" id="accordionPanelsStayOpenExample">
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                                        <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                                            Cutting-Edge AIoT and Machine <br />Perception Technology
                                        </button>
                                    </h2>
                                    <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                                        <div class="accordion-body">
                                            Our cutting-edge AIoT (Artificial Intelligence of Things) and Machine Perception Technology seamlessly integrate AI with IoT devices, enabling smart, automated decision-making. This technology allows systems to analyze and respond to real-time data, enhancing efficiency and performance across various industries. By combining intelligent algorithms with advanced sensors, we empower businesses to unlock new possibilities and optimize operations.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
                                            Comprehensive, Industry-Specific Solutions <br />for Global Markets
                                        </button>
                                    </h2>
                                    <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTwo">
                                        <div class="accordion-body">
                                            We offer comprehensive, industry-specific solutions tailored to meet the unique needs of global markets. Our products and services are designed to address the challenges and opportunities within each sector, ensuring relevance and impact across diverse regions. By leveraging deep industry expertise and cutting-edge technology, we deliver customized solutions that drive growth, efficiency, and innovation worldwide.
                                        </div>
                                    </div>
                                </div>
                                <div class="accordion-item">
                                    <h2 class="accordion-header" id="panelsStayOpen-headingThree">
                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
                                            Global Presence with Localized <br />Support
                                        </button>
                                    </h2>
                                    <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingThree">
                                        <div class="accordion-body">
                                            With a global presence, we ensure that our customers receive personalized, localized support wherever they are. Our teams are strategically located to offer timely assistance, tailored solutions, and on-the-ground expertise. This approach allows us to address regional needs while maintaining the high standards of service and quality expected from a global leader.
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            <CustomizedAccordions />
                        </div>
                    </div>
                </div>
            </section>

            {/* HOW WE WORK */}
            <section className="How-we-work-section-adhiba ">
                <div className="How-we-work-heading-div">
                    <h3>How we work?</h3>
                    <p>We work by integrating advanced technology, precision manufacturing, and a customer-first approach to deliver innovative, <br />high-quality smart solutions on time and at the right cost.</p>
                </div>
                {/* 4 cards */}
                <div className="container mt-5 mb-3 How-we-work-heading-cards">
                    <div className="row">
                        <div class="card col-lg-3" style={{ backgroundColor: "#393185D9" }}>
                            <div class="card-body">
                                <h5 class="card-title">01</h5>
                                <h6 class="card-subtitle mb-2">Innovative Product Development</h6>
                                <p class="card-text">We design and develop cutting-edge hardware and software solutions tailored to modern needs, blending advanced technology with user-centric innovation for seamless integration into daily life.</p>
                                {/* <div className="hover-icon-adhiba">
                                    <FontAwesomeIcon icon={faAngleRight} />
                                </div> */}
                            </div>
                        </div>
                        <div class="card col-lg-3" style={{ backgroundColor: "#393185" }}>
                            <div class="card-body">
                                <h5 class="card-title">02</h5>
                                <h6 class="card-subtitle mb-2">Precision Manufacturing</h6>
                                <p class="card-text">Utilizing state-of-the-art facilities, we ensure every product meets rigorous quality standards, delivering reliable and durable solutions for electronic manufacturing and smart home systems.</p>
                                {/* <div className="hover-icon-adhiba">
                                    <FontAwesomeIcon icon={faAngleRight} />
                                </div> */}
                            </div>
                        </div>
                        <div class="card col-lg-3" style={{ backgroundColor: "#3D3D3F" }}>
                            <div class="card-body">
                                <h5 class="card-title">03</h5>
                                <h6 class="card-subtitle mb-2">Efficient Logistics and Delivery</h6>
                                <p class="card-text">With a streamlined logistics network, we prioritize on-time delivery, ensuring our customers receive their products promptly and in perfect condition, every single time.</p>
                                {/* <div className="hover-icon-adhiba">
                                    <FontAwesomeIcon icon={faAngleRight} />
                                </div> */}
                            </div>
                        </div>
                        <div class="card col-lg-3" style={{ backgroundColor: "#090909" }}>
                            <div class="card-body">
                                <h5 class="card-title">04</h5>
                                <h6 class="card-subtitle mb-2">Customer-Centric Approach</h6>
                                <p class="card-text">We prioritize customer satisfaction through personalized support, innovative solutions, and exceptional service.</p>
                                {/* <div className="hover-icon-adhiba">
                                    <FontAwesomeIcon icon={faAngleRight} />
                                </div> */}
                            </div>
                        </div>


                    </div>
                </div>
            </section>

            {/* 2 IMAGES */}
            <center className=" mission-vission-section">

                <div className="container">

                    <div className="mission-vission-heading-div mb-5">
                        <h3>Our Vision and Mission statements</h3>
                        <p>Our mission is to enhance lives with innovative smart solutions, while our vision is to lead globally<br /> through excellence and innovation.</p>
                    </div>

                    {/* <img src={twoimg1} className="img-fluid w-75" style={{ borderRadius: "0%" }} /> */}

                    <div className="row">
                        <div className="col-lg-6 mission-vission-2card-left-div">
                            <div class="card">
                                <div class="card-body">
                                    <img src={ourvisionimg1} className="img-fluid" />
                                    <h5 class="card-title">Our Mission:</h5>
                                    <p class="card-text">To empower modern living by delivering innovative, high-quality smart home solutions that enhance convenience, improve lifestyles, and exceed customer expectations through precision manufacturing and timely delivery.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6 mission-vission-2card-right-div">
                            <div class="card">
                                <div class="card-body">
                                    <img src={ourvisionimg1} className="img-fluid" />
                                    <h5 class="card-title">Our Vision:</h5>
                                    <p class="card-text">To be a global leader in smart technology and electronics, revolutionizing everyday life with cutting-edge solutions that combine excellence in quality, affordability, and sustainability, while continuously driving innovation and customer satisfaction.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

            </center>

            {/* Testimonial */}
            <Testimonial />

            {/* FOOTER ADHIBA */}
            <Footer />

        </>
    )
}




const Accordion = styled((props) => (
    <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
    border: `1px solid ${theme.palette.divider}`,
    '&:not(:last-child)': {
        borderBottom: 0,
    },
    '&::before': {
        display: 'none',
    },
}));

const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon
            sx={{
                backgroundColor: '#313985',
                color: 'white',
                '& .MuiAccordionSummary-root': {
                    color: 'white',
                },
                '& .MuiAccordionDetails-root': {
                    color: 'white',
                },
                fontSize: "15px"
            }}
        />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: 'rgba(0, 0, 0, .03)',
    flexDirection: 'row-reverse',
    [`& .${accordionSummaryClasses.expandIconWrapper}.${accordionSummaryClasses.expanded}`]:
    {
        transform: 'rotate(90deg)',
    },
    [`& .${accordionSummaryClasses.content}`]: {
        marginLeft: theme.spacing(1),
    },
    ...theme.applyStyles('dark', {
        backgroundColor: 'rgba(255, 255, 255, .05)',
    }),
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
    padding: theme.spacing(2),
    borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

function CustomizedAccordions() {
    const [expanded, setExpanded] = React.useState('panel1');

    const handleChange = (panel) => (event, newExpanded) => {
        setExpanded(newExpanded ? panel : false);
    };

    return (
        <>
            <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header"
                    sx={{
                        backgroundColor: '#313985',
                        color: 'white',
                        '& .MuiAccordionSummary-root': {
                            color: 'white',
                        },
                        '& .MuiAccordionDetails-root': {
                            color: 'white',
                        },
                        padding: "10px",
                        borderRadius: "5px"
                    }}
                >
                    <Typography component="span"> Cutting-Edge AIoT and Machine Perception Technology</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography className="accordion-body">
                        Our cutting-edge AIoT (Artificial Intelligence of Things) and Machine Perception Technology seamlessly integrate AI with IoT devices, enabling smart, automated decision-making. This technology allows systems to analyze and respond to real-time data, enhancing efficiency and performance across various industries. By combining intelligent algorithms with advanced sensors, we empower businesses to unlock new possibilities and optimize operations.
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')}>
                <AccordionSummary aria-controls="panel2d-content" id="panel2d-header"
                    sx={{
                        backgroundColor: '#313985',
                        color: 'white',
                        '& .MuiAccordionSummary-root': {
                            color: 'white',
                        },
                        '& .MuiAccordionDetails-root': {
                            color: 'white',
                        },
                        padding: "10px",
                        borderRadius: "5px"
                    }}
                >
                    <Typography component="span">   Comprehensive, Industry-Specific Solutions for Global Markets</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography className="accordion-body">
                        We offer comprehensive, industry-specific solutions tailored to meet the unique needs of global markets. Our products and services are designed to address the challenges and opportunities within each sector, ensuring relevance and impact across diverse regions. By leveraging deep industry expertise and cutting-edge technology, we deliver customized solutions that drive growth, efficiency, and innovation worldwide.
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion expanded={expanded === 'panel3'} onChange={handleChange('panel3')}>
                <AccordionSummary aria-controls="panel3d-content" id="panel3d-header"
                    sx={{
                        backgroundColor: '#313985',
                        color: 'white',
                        '& .MuiAccordionSummary-root': {
                            color: 'white',
                        },
                        '& .MuiAccordionDetails-root': {
                            color: 'white',
                        },
                        padding: "10px",
                        borderRadius: "5px"
                    }}
                >
                    <Typography component="span"> Global Presence with Localized Support</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography className="accordion-body">
                        With a global presence, we ensure that our customers receive personalized, localized support wherever they are. Our teams are strategically located to offer timely assistance, tailored solutions, and on-the-ground expertise. This approach allows us to address regional needs while maintaining the high standards of service and quality expected from a global leader.
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </>
    );
}